import { render, staticRenderFns } from "./MassBalance.vue?vue&type=template&id=b2fe3c10&scoped=true"
import script from "./MassBalance.vue?vue&type=script&lang=js"
export * from "./MassBalance.vue?vue&type=script&lang=js"
import style0 from "./MassBalance.vue?vue&type=style&index=0&id=b2fe3c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fe3c10",
  null
  
)

export default component.exports